import { withNamespaces } from "react-i18next";
import { Badge, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import {
    INTERNATIONAL_DATE_FORMAT
} from 'src/common/constants';
import {
    DDSActivityTypes,
    DDSStatuses
} from "src/modules/3rd-party-management/constants";

const Header = ({
    t,
    isLoading,
    traceData = {}
}) => {
    const  {
        status, 
        referenceNumber, 
        activityType
    } = traceData;

    const dateUtils = new DateUtils();

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h5" className="mb-3">
                    {t('General Information')}
                </CardTitle>

                <Row>
                    <Col sm="12" md="6" lg="3" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-hashtag"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Reference Number')}
                                </Label>
                                {isLoading ? (
                                    <div
                                        className="dt-field dt-skeleton"
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <p className="text-muted mb-0">
                                        {referenceNumber}
                                    </p>
                                )}
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg="3" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-exchange-box-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Activity Type')}
                                </Label>
                                {isLoading ? (
                                    <div
                                        className="dt-field dt-skeleton"
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <p className="text-muted mb-0">
                                        {t(DDSActivityTypes[activityType]?.title || activityType)}
                                    </p>
                                )}
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg="3" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-file-list-2-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Statement Status')}
                                </Label>
                                {isLoading ? (
                                    <div
                                        className="dt-field dt-skeleton"
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <p className="mb-0">
                                        <Badge
                                            className={`bg-${DDSStatuses[status?.status]?.color || 'secondary'}`}
                                        >
                                            {DDSStatuses[status?.status]?.icon || null}
                                            {t(DDSStatuses[status?.status]?.title || status?.status)}
                                        </Badge>
                                    </p>
                                )}
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg="3" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-calendar-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Status Date')}
                                </Label>
                                {isLoading ? (
                                    <div
                                        className="dt-field dt-skeleton"
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <p className="text-muted mb-0">
                                        {dateUtils.convertDateToDate(
                                            status?.importDate,
                                            INTERNATIONAL_DATE_FORMAT
                                        )}
                                    </p>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    Header
);